import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.events = {
      click: {
        close: 'close',
      },
      change: {
        country: 'getPlatforms'
      }
    };
  }

  open() {
    this.el.showModal();
  }

  close() {
    this.el.close();
  }

  setupOpenCloseAnimation() {
    const originalShowModal = this.el.showModal;
    const originalClose = this.el.close;

    this.el.showModal = () => {
      originalShowModal.call(this.el);
      this.el.classList.add('is-open');
    };

    this.el.close = () => {
      this.el.addEventListener(
        'transitionend',
        (ev) => originalClose.call(this.el),
        {once: true}
      );
      this.el.classList.remove('is-open');
    }
  }

  getPlatforms( event ) {
    const formData = new FormData( event.target.closest('form') );

    fetch( RSQ_XHR.url, {
      method: 'POST',
      credentials: 'same-origin',
      body: formData
    } )
      .then( res => res.ok ? res.json() : Promise.reject( res ) )
      .then( response => {
        if ( response.success ) {
          let platformsList = '';
          response.data.platforms.forEach( platform => {
            platformsList += `
              <article class="c-user-access_platform">
                <div class="c-user-access_platform_image"><img src="${ platform.image }" alt="" /></div>
                <h3 class="c-user-access_platform_name">${ platform.name }</h3>
                <a class="c-user-access_platform_link | o-button" href="${ platform.url }" target="_blank" rel="external">
                  <span>Accesar</span>
                  <svg viewBox="0 0 1 1" width="30" height="30">
                    <use xlink:href="#ui-arrow-right"></use>
                  </svg>
                </a>
              </article>
            `;
          } );
          this.$('platforms')[0].innerHTML = platformsList;
        }
      } )
      .catch( error => {
        console.log( error.message );
      } )
    ;
    console.log('retrieve platforms via API');
  }

  init() {
    this.setupOpenCloseAnimation();
  }
}
